<template>
  <div v-loading.fullscreen="loading"
       element-loading-text="正在登陆中"
       element-loading-spinner="el-icon-loading">
  </div>
</template>

<script>
import { permission } from '@/router/permission'
export default {
  data () {
    return {
      loading: true
    }
  },
  components: {},
  created () {
    const userInfoVO = {
      token: this.$route.query.token
    }
    localStorage.setItem('userInfo', JSON.stringify(userInfoVO))
  },
  mounted () {
    localStorage.setItem('isPortal', '1');
    this.userLogin();
  },
  computed: {},
  methods: {
    userLogin () {
      let _this = this;
      const obj = {
        marketCode: _this.$route.query.code
      };
      _this.$http.portalLogin(obj).then(({ status, data, msg }) => {
        this.loading = false
        if (status === 200) {
        const { userInfoVO: { menus = [] }} = data
          if(!menus || !menus.length) {
            return this.$message.error('当前用户没有任何权限')
          }
          localStorage.setItem('userInfo', JSON.stringify(data))
          permission()
          _this.$router.push('/')
        } else {
          _this.$message.error(msg);
        }
      });
    }
  },
  watch: {}
}
</script>

<style scoped>
</style>
